import { useBranding } from "@/context/BrandingContext";
import { Radio } from "lucide-react";

export function Logo({ compact = false }) {
  const branding = useBranding();
  return (
    <div className="flex items-center gap-2" data-testid="app-logo">
      <div className="relative flex h-7 w-7 items-center justify-center rounded-md bg-zinc-50">
        {branding.logo_data ? <img src={branding.logo_data} alt={branding.display_name || "Logo"} className="h-7 w-7 rounded object-contain" /> : branding.logo_text ? <span className="text-xs font-semibold" style={{ color: branding.accent_color }}>{branding.logo_text}</span> : <Radio className="h-4 w-4 text-zinc-900" />}
      </div>
      {!compact && (
        <span className="font-semibold tracking-tight text-zinc-50 text-[15px]">
          {branding.display_name || <>Live<span className="text-zinc-400">Core</span></>}
        </span>
      )}
    </div>
  );
}
